import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import moment from 'moment';
import Confirm from 'react-confirm-bootstrap';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../../components/Link';
import CustomPagination from '../../CustomPagination';
import CommonTable from '../../CommonTable/CommonTable';
import Loader from '../../Loader/Loader'

import messages from '../../../locale/messages';
import { debounce } from '../../../helpers/debounce';
import { deleteUser } from '../../../actions/siteadmin/users';
import { updateBanServiceHistoryStatus } from '../../../actions/siteadmin/updateBanServiceHistoryStatus';
import { demoRestriction, demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import usersQuery from './usersQuery.graphql';
import { withQuery } from '../../../hoc/withGraphql';
import { decode } from '../../../helpers/queryEncryption';
import { censorEmail, censorPhone } from '../../../helpers/secureEmail';

import s from './UserManagement.css';
import bt from '../../../components/commonStyle.css';
class UserManagement extends React.Component {
  static propTypes = {
    editUser: PropTypes.any,
    deleteUser: PropTypes.any,
    updateBanServiceHistoryStatus: PropTypes.any.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      value: '',
      typing: false,
      typingTimeout: 0,
      isRestrict: false
    }
  }

  async componentDidMount() {
    const { demoRestrictionEncode } = this.props;
    const isRestrict = await demoRestrictionEncode();
    this.setState({ isRestrict });
  }

  handleChange = async (e, userId, userMail, userName) => {
    const { updateBanServiceHistoryStatus, demoRestriction, currentPage, searchList } = this.props;
    let id = userId, banStatus = e.target.value;
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await updateBanServiceHistoryStatus(id, banStatus, userMail, userName, currentPage, searchList);
  }

  handleDropDown = (e) => {
    const { userManagement: { refetch }, setStateVariable } = this.props
    let variables = {
      userType: e.target.value,
      currentPage: 1
    };
    setStateVariable({ userType: e.target.value, currentPage: 1 });
    refetch(variables)
  }

  paginationData = (currentPage) => {
    const { userManagement: { refetch }, setStateVariable } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    setStateVariable(variables);
    refetch(variables);
  }

  handleSearchChange = (searchList) => {
    const { userManagement: { refetch }, setStateVariable, userType } = this.props;
    let variables = {
      currentPage: 1,
      searchList,
      userType
    };
    setStateVariable(variables);
    refetch(variables);
  }

  deleteChange = async (id, profileId, userTypes) => {
    const { deleteUser, setStateVariable, currentPage, userManagement: { refetch, userManagement }, demoRestriction } = this.props;
    let variables = { currentPage: currentPage > 1 && userManagement?.usersData?.length == 1 ? currentPage - 1 : currentPage };
    const isRestrict = await demoRestriction({});
    if (isRestrict) return;
    await deleteUser(id, profileId, userTypes);
    await setStateVariable(variables);
    await refetch(variables);
  }


  thead = () => {
    const { formatMessage } = this.props.intl;
    return [
      { data: formatMessage(messages.profileID) },
      { data: formatMessage(messages.firstName) },
      { data: formatMessage(messages.lastName) },
      { data: formatMessage(messages.email) },
      { data: formatMessage(messages.phoneNumber) },
      { data: formatMessage(messages.createdDate) },
      { data: formatMessage(messages.viewLabel) },
      { data: formatMessage(messages.editLabel) },
      { data: formatMessage(messages.actionLabel) },
      { data: formatMessage(messages.delete) },
    ]
  }

  tbody = (props) => {
    const { userManagement: { userManagement } } = props;
    const { formatMessage } = props.intl;
    const { isRestrict } = this.state;

    return userManagement?.usersData?.map((value, key) => {
      let banStatus = value?.userBanStatus, recordId = value?.id;
      let userMail = decode(value?.email), userName = value?.profile?.firstName + ' ' + value?.profile?.lastName;
      let phoneNumber = decode(value?.profile?.phoneNumber), userTypes = 'admin';
      banStatus = banStatus === 1 ? "1" : "0";

      return {
        id: key,
        data: [
          { data: value?.profile?.profileId, },
          { data: value?.profile?.firstName },
          { data: value?.profile?.lastName },
          { data: !isRestrict ? userMail : censorEmail(userMail) },
          { data: value?.profile?.countryCode && value?.profile?.phoneNumber && value?.profile?.countryCode + (!isRestrict ? phoneNumber : censorPhone(phoneNumber)) },
          { data: moment(parseInt(value?.profile?.createdAt)).format('MM/DD/YYYY') },
          {
            data: <Link to={"/siteadmin/profile-view/" + ((value?.profile) ? value?.profile?.profileId : '')} >
              <FormattedMessage {...messages.viewLabel} />
            </Link>
          },
          {
            data: <Link to={"/siteadmin/edit-profile/" + ((value?.profile) ? value?.profile?.profileId : '')} >
              <FormattedMessage {...messages.editLabel} />
            </Link>
          },
          {
            data: <select name="userBanStatus" onChange={(e) => this.handleChange(e, recordId, userMail, userName)} value={banStatus}>
              <option value="">{formatMessage(messages.selectLabel)}</option>
              <option value="1">{formatMessage(messages.banLabel)}</option>
              <option value="0">{formatMessage(messages.unBanLabel)}</option>
            </select>
          },
          {
            data: <Confirm
              onConfirm={() => this.deleteChange(value?.id, value?.profile?.profileId, userTypes)}
              body={formatMessage(messages.areYouSureDeleteWishList)}
              confirmText={formatMessage(messages.confirmDelete)}
              cancelText={formatMessage(messages.cancel)}
              title={formatMessage(messages.deletingUser)}>
              <a href="javascript:void(0)"><FormattedMessage {...messages.delete} /></a>
            </Confirm>
          }
        ]
      }
    })
  }

  tableFilter = () => {
    const { formatMessage } = this.props.intl;
    return [
      { value: "", label: formatMessage(messages.allLabel) },
      { value: "1", label: formatMessage(messages.guest) },
      { value: "2", label: formatMessage(messages.host) }
    ]
  }

  render() {
    const { userManagement: { loading, userManagement }, isLoading } = this.props;
    const { searchList, userType, currentPage } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div>
        {isLoading && <Loader type={"text"} />}
        {!isLoading && <div>
          <CommonTable
            title={formatMessage(messages.manageUser)}
            thead={this.thead}
            tbody={() => this.tbody(this.props)}
            isSearch
            filterOption={this.tableFilter()}
            handleFilter={(e) => this.handleDropDown(e)}
            handleSearch={(e) => debounce(this.handleSearchChange(e?.target?.value))}
            exportURL={userManagement?.usersData?.length > 0 ? "/export-admin-data?type=users&usertype=" + userType + "&keyword=" + searchList : null}
            loading={loading}
          />
          {
            userManagement?.usersData?.length > 0 && <div>
              <CustomPagination
                total={userManagement.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.usersLabel)}
                isScroll
              />
            </div>
          } </div>}
      </div>
    );
  }
}

const mapState = (state) => ({
});

const mapDispatch = {
  updateBanServiceHistoryStatus,
  deleteUser,
  demoRestriction,
  demoRestrictionEncode
};

export default compose(
  injectIntl,
  withStyles(s, bt),
  connect(mapState, mapDispatch),
  withQuery(usersQuery, {
    name: 'userManagement',
    options: (props) => ({
      variables: {
        currentPage: props.currentPage,
        searchList: props.searchList,
        userType: props.userType
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(UserManagement);